import Collapse from 'rc-collapse';
import './scss/Collapse.scss';

export default Collapse;
